export const LANGS = ["it", "en"];

export const MGA_RATE = 4900; // tasso indicativo EUR -> MGA (Ariary)

export const ROUTES = {
  it: {
    home: "", properties: "immobili", beachfront: "immobili/fronte-mare", land: "immobili/terreni",
    houses: "immobili/case-ville", hospitality: "immobili/strutture-turistiche", sold: "immobili/venduti",
    property: "immobile", farmland: "terreni-agricoli", services: "servizi", service: "servizi",
    zones: "zone", zone: "zone", guides: "guide", article: "guide", freeGuide: "guida-gratuita",
    tools: "strumenti", howItWorks: "come-funziona", about: "chi-siamo", testimonials: "testimonianze",
    faq: "domande-frequenti", contact: "contatti", sell: "vendi-con-noi", privacy: "privacy",
    cookies: "cookie", terms: "termini", risks: "avvertenze-rischi",
  },
  en: {
    home: "", properties: "properties", beachfront: "properties/beachfront", land: "properties/land",
    houses: "properties/houses-villas", hospitality: "properties/hospitality", sold: "properties/sold",
    property: "property", farmland: "farmland", services: "services", service: "services",
    zones: "areas", zone: "areas", guides: "guides", article: "guides", freeGuide: "free-guide",
    tools: "tools", howItWorks: "how-it-works", about: "about", testimonials: "testimonials",
    faq: "faq", contact: "contact", sell: "list-your-property", privacy: "privacy-policy",
    cookies: "cookie-policy", terms: "terms", risks: "risk-disclosure",
  },
};

export const linkTo = (lang, key, slug) => {
  const base = lang === "en" ? "/en" : "";
  const p = ROUTES[lang][key] ?? "";
  const path = `${base}${p ? "/" + p : ""}${slug ? "/" + slug : ""}`;
  return path || "/";
};

export const alternatePath = (pathname, fromLang) => {
  const to = fromLang === "it" ? "en" : "it";
  let rel = pathname;
  if (fromLang === "en") rel = pathname.replace(/^\/en/, "") || "/";
  rel = rel.replace(/\/+$/, "") || "/";
  if (rel === "/") return to === "en" ? "/en/" : "/";
  const entries = Object.entries(ROUTES[fromLang])
    .filter(([, base]) => base)
    .sort((a, b) => b[1].length - a[1].length);
  for (const [key, base] of entries) {
    if (rel === "/" + base) return linkTo(to, key);
    if (rel.startsWith("/" + base + "/")) {
      const rest = rel.slice(base.length + 2);
      return linkTo(to, key, rest);
    }
  }
  return to === "en" ? "/en/" : "/";
};

export const formatPrice = (n, lang) => {
  if (n == null) return "";
  const num = Number(n);
  if (lang === "it") return `${num.toLocaleString("it-IT")} €`;
  return `€${num.toLocaleString("en-US")}`;
};

export const formatMGA = (n, lang) => {
  const mga = Math.round(Number(n) * MGA_RATE);
  return lang === "it" ? `${mga.toLocaleString("it-IT")} Ar` : `Ar ${mga.toLocaleString("en-US")}`;
};

export const formatSurface = (m2, lang) => {
  const n = Number(m2);
  const sqm = `${n.toLocaleString(lang === "it" ? "it-IT" : "en-US")} m²`;
  if (n >= 10000) {
    const ha = (n / 10000).toLocaleString(lang === "it" ? "it-IT" : "en-US", { maximumFractionDigits: 1 });
    return `${sqm} (${ha} ha)`;
  }
  return sqm;
};

export const TYPE_KEYS = ["beachfront", "land", "house", "villa", "hospitality", "farmland"];

export const T = {
  it: {
    brand: "Investire in Madagascar",
    nav: {
      properties: "Immobili", farmland: "Terreni agricoli", services: "Servizi", zones: "Zone",
      guides: "Guide", about: "Chi siamo", contact: "Contatti", cta: "Prenota una consulenza",
      tools: "Strumenti", howItWorks: "Come funziona", testimonials: "Testimonianze", faq: "FAQ", sell: "Vendi con noi",
    },
    common: {
      all: "Tutti", readMore: "Leggi tutto", viewProperty: "Vedi l'immobile", featured: "In evidenza",
      example: "Esempio", available: "Disponibile", reserved: "Riservato", sold: "Venduto",
      priceOnRequest: "Prezzo su richiesta", photosComingSoon: "Foto reali in arrivo",
      back: "Indietro", close: "Chiudi", send: "Invia", sending: "Invio in corso...",
      required: "Campo obbligatorio", invalidEmail: "Email non valida",
      errorGeneric: "Qualcosa è andato storto. Riprova o scrivici direttamente.",
      privacyRequired: "Devi accettare l'informativa privacy per continuare",
      grid: "Griglia", list: "Lista", compare: "Confronta", favorites: "Preferiti",
      results: "risultati", fromSea: "dal mare", fromAirport: "dall'aeroporto", built: "Sup. costruita",
      landSurface: "Superficie", disclaimerShort: "Le informazioni hanno scopo informativo e non costituiscono consulenza legale, fiscale o finanziaria.",
      demoData: "Annuncio dimostrativo con dati inventati, da sostituire prima del lancio",
      menu: "Menu", search: "Cerca", newOpportunity: "Nuova opportunità",
    },
    types: {
      beachfront: "Fronte mare", land: "Terreni", house: "Case", villa: "Ville",
      hospitality: "Strutture turistiche", farmland: "Agricolo",
    },
    hero: {
      line1: "Terra rossa,",
      line2: "oceano profondo,",
      line3: "il tuo investimento.",
      subtitle: "Terreni, immobili e terreni agricoli verificati in Madagascar. Ti accompagniamo in ogni passaggio, dalla prima visita alla firma dal notaio — con onestà su rischi e costi.",
      searchTitle: "Trova la tua opportunità",
      typeLabel: "Tipologia", zoneLabel: "Zona", budgetLabel: "Budget",
      budgetAny: "Qualsiasi budget", zoneAny: "Tutte le zone", typeAny: "Tutte le tipologie",
      submit: "Cerca immobili",
      budgetOptions: ["Meno di 20.000 €", "20.000–50.000 €", "50.000–150.000 €", "Oltre 150.000 €"],
      scroll: "Scorri",
    },
    trust: {
      title: "Un metodo, non promesse",
      items: [
        { value: "9", label: "Zone coperte in tutto il Paese" },
        { value: "[XX]", label: "Anni di esperienza — dato da confermare" },
        { value: "[XXX]", label: "Clienti assistiti — dato da confermare" },
        { value: "100%", label: "Annunci con scheda di trasparenza" },
      ],
    },
    home: {
      featuredTitle: "Opportunità in evidenza",
      featuredSub: "Una selezione di annunci verificati dal nostro team. Ogni immobile include la scheda di trasparenza: cosa abbiamo controllato e quali rischi restano.",
      viewAll: "Vedi tutti gli immobili",
      mapTitle: "Un'isola, nove mondi",
      mapSub: "Dalle lagune di Nosy Be agli altopiani agricoli: esplora le zone dove lavoriamo e scopri quale fa per te.",
      mapCta: "Esplora le zone",
      stepsTitle: "Come funziona",
      stepsSub: "Quattro passaggi chiari, un unico referente che parla la tua lingua.",
      servicesTitle: "Non solo immobili",
      servicesSub: "Verifica legale, costituzione società, residenza, viaggi di sopralluogo e gestione: un ponte completo tra te e il Madagascar.",
      allServices: "Tutti i servizi",
      residencyTitle: "Vivere in Madagascar",
      residencyText: "Percorsi di residenza per investitori, pensionati e lavoratori. Ti aiutiamo a capire requisiti, tempi e documenti — e ti diciamo subito se la tua situazione non è adatta.",
      residencyCta: "Scopri il programma residenza",
      whyTitle: "Perché il Madagascar",
      whySub: "Un mercato di frontiera: prezzi d'ingresso bassi e grandi potenzialità, ma anche rischi reali. Ecco i fatti, senza retorica.",
      zonesTitle: "Le zone dove investire",
      zonesSub: "Nove aree che conosciamo sul campo, ciascuna con il suo profilo: turismo, residenza, agricoltura.",
      testimonialsTitle: "Chi ha già investito con noi",
      testimonialsNote: "Le testimonianze pubblicate sono solo quelle reali e autorizzate per iscritto. Queste sono schede dimostrative da sostituire prima del lancio.",
      guideTitle: "La guida gratuita per iniziare",
      guideSub: "“Investire in Madagascar: la guida onesta” — 40 pagine su mercato, leggi, costi reali ed errori da evitare.",
      guideCta: "Scarica la guida gratuita",
      guideSuccess: "Fatto! Controlla la tua email: ti abbiamo inviato il link per scaricare la guida.",
      articlesTitle: "Guide e approfondimenti",
      articlesSub: "Articoli pratici scritti da chi lavora sul campo, non da chi vende sogni.",
      allArticles: "Tutti gli articoli",
      faqTitle: "Domande frequenti",
      faqSub: "Le risposte che diamo più spesso, senza giri di parole.",
      allFaq: "Tutte le FAQ",
      ctaTitle: "Parliamone, senza impegno",
      ctaSub: "Raccontaci che idea hai: ti diremo con onestà se e come si può realizzare in Madagascar.",
      ctaButton: "Prenota una consulenza gratuita",
      marquee: "Titoli verificati • Accompagnamento in italiano • Schede di trasparenza • Nessun rendimento promesso • Sopralluoghi organizzati • Supporto legale locale • ",
    },
    listings: {
      title: "Tutti gli immobili",
      sub: "Ogni annuncio include cosa abbiamo verificato e quali rischi restano. Nessuna sorpresa dopo la firma.",
      filters: "Filtri", type: "Tipologia", zone: "Zona", priceMin: "Prezzo min", priceMax: "Prezzo max",
      surfaceMin: "Superficie min (m²)", beachfrontOnly: "Solo fronte mare", statusLabel: "Stato",
      reset: "Azzera filtri", sortNewest: "Più recenti", sortPriceAsc: "Prezzo crescente", sortPriceDesc: "Prezzo decrescente", sortSurface: "Superficie",
      empty: "Nessun immobile corrisponde ai filtri. Prova ad allargare la ricerca o contattaci: spesso conosciamo opportunità non ancora pubblicate.",
      compareBar: "immobili selezionati per il confronto", compareNow: "Confronta ora", compareTitle: "Confronto immobili",
      compareMax: "Puoi confrontare al massimo 3 immobili",
      favAdded: "Aggiunto ai preferiti", favRemoved: "Rimosso dai preferiti", showFavs: "Mostra preferiti",
      refCode: "Codice", price: "Prezzo", surface: "Superficie", zoneCol: "Zona",
      presetTitles: { beachfront: "Terreni fronte mare", land: "Terreni edificabili", houses: "Case e ville", hospitality: "Strutture turistiche", sold: "Immobili venduti", farmland: "Terreni agricoli" },
      presetSubs: {
        beachfront: "Lotti verificati direttamente sulla spiaggia o con accesso diretto al mare.",
        land: "Terreni edificabili e residenziali con titolo verificato.",
        houses: "Case e ville pronte o da ristrutturare.",
        hospitality: "Lodge, boutique hotel e strutture ricettive.",
        sold: "Archivio degli immobili venduti: per capire prezzi e tempi reali del mercato.",
        farmland: "Terreni agricoli fertili, con acqua e titolo verificato.",
      },
    },
    property: {
      keyFacts: "Dati principali", description: "Descrizione", transparency: "Scheda di trasparenza",
      rightType: "Tipo di diritto offerto", titleStatus: "Stato del titolo", checks: "Verifiche effettuate",
      risks: "Rischi noti", extraCosts: "Costi accessori indicativi",
      extraCostsText: "Verifica legale, notaio, registrazione e eventuale costituzione società non sono inclusi nel prezzo. Stima orientativa: 8–15% del prezzo d'acquisto. Usa il calcolatore dei costi per un dettaglio.",
      mapTitle: "Posizione", approxLocation: "Posizione indicativa: per ragioni di privacy il punto esatto viene condiviso dopo il primo contatto.",
      similar: "Immobili simili", contactTitle: "Richiedi informazioni",
      contactSub: "Compila il modulo: ti rispondiamo entro 24 ore lavorative, in italiano.",
      whatsappMsg: "Salve, ho visto l'immobile {ref} ({title}) su Investire in Madagascar e vorrei maggiori informazioni.",
      updated: "Annuncio aggiornato il", mortgage: "Scheda verificata dal nostro team",
    },
    farmlandPage: {
      title: "Terreni agricoli",
      sub: "Terreni fertili con acqua, titolo verificato e — se vuoi — gestione locale. L'agricoltura è uno dei settori con più potenziale in Madagascar, ma richiede competenza e pazienza.",
      whyTitle: "Perché l'agricoltura in Madagascar",
      whyPoints: [
        { t: "Terre fertile a prezzi accessibili", d: "Sugli altopiani e sulla costa i prezzi al ettaro sono una frazione di quelli europei, con climi che permettono più raccolti l'anno." },
        { t: "Acqua e clima", d: "Molte zone hanno piogge abbondanti o sorgive. Verifichiamo sempre i diritti idrici prima di proporti un terreno." },
        { t: "Gestione anche a distanza", d: "Con accordi di conduzione locale puoi produrre anche senza vivere sul posto. Ti presentiamo realtà collaudate." },
      ],
      cta: "Vedi i terreni agricoli disponibili",
    },
    form: {
      name: "Nome e cognome", email: "Email", phone: "Telefono / WhatsApp", phoneHint: "Con prefisso internazionale, es. +39",
      country: "Paese di residenza", budget: "Fascia di budget", timeline: "Tempistica",
      timelineOptions: ["Entro 3 mesi", "3–12 mesi", "Oltre un anno", "Mi sto solo informando"],
      budgetOptions: ["Meno di 20.000 €", "20.000–50.000 €", "50.000–150.000 €", "Oltre 150.000 €"],
      message: "Messaggio", contactPref: "Come preferisci essere ricontattato?",
      contactPrefOptions: ["Email", "WhatsApp", "Videochiamata"],
      privacy: "Ho letto e accetto l'informativa privacy",
      newsletter: "Voglio ricevere la newsletter mensile con nuove opportunità (facoltativo)",
      submit: "Invia la richiesta", success: "Richiesta inviata! Ti ricontatteremo entro 24 ore lavorative.",
      selectPlaceholder: "Seleziona...",
      countries: ["Italia", "Francia", "Germania", "Svizzera", "Spagna", "Regno Unito", "Belgio", "Paesi Bassi", "Austria", "Altro"],
      messagePrefill: "Salve, vorrei maggiori informazioni su \"{title}\" (cod. {ref}).",
      guideName: "Nome", guideEmail: "La tua email", guideSubmit: "Scarica la guida",
      newsletterSubmit: "Iscriviti", newsletterSuccess: "Iscrizione confermata. Benvenuto a bordo!",
    },
    popup: {
      title: "Prima di andare: la guida gratuita",
      text: "“Investire in Madagascar: la guida onesta” — mercato, leggi, costi reali ed errori da evitare. 40 pagine, zero pubblicità.",
      later: "No grazie, magari più avanti",
    },
    cookie: {
      title: "Rispettiamo la tua privacy",
      text: "Usiamo cookie tecnici per far funzionare il sito e — solo con il tuo consenso — cookie di misurazione per capire come viene usato. Nessun tracciamento parte senza il tuo ok.",
      accept: "Accetta", reject: "Rifiuta", customize: "Personalizza", save: "Salva le preferenze",
      necessary: "Tecnici (sempre attivi)", analytics: "Misurazione anonima", marketing: "Marketing",
    },
    footer: {
      tagline: "Il ponte trasparente tra investitori europei e opportunità immobiliari e agricole verificate in Madagascar.",
      explore: "Esplora", company: "Società", legal: "Note legali", contacts: "Contatti",
      newsletterTitle: "Nuove opportunità, una volta al mese",
      newsletterSub: "Solo annunci verificati e un articolo dalle nostre guide. Niente spam.",
      companyData: "[RAGIONE SOCIALE] · [INDIRIZZO SEDE] · [P.IVA / IDENTIFICATIVO ESTERO]",
      email: "[EMAIL]", whatsapp: "[NUMERO WHATSAPP]",
      disclaimer: "Le informazioni pubblicate hanno scopo informativo e non costituiscono consulenza legale, fiscale o finanziaria. Gli investimenti all'estero comportano rischi, inclusa la possibile perdita del capitale. Prima di qualunque decisione consulta professionisti qualificati.",
      rights: "Tutti i diritti riservati.",
    },
    tools: {
      title: "Strumenti per decidere",
      sub: "Numeri alla mano: calcola i costi reali, converti in Ariary, confronta le zone e scopri quale investimento fa per te.",
      calc: "Calcolatore costi", converter: "Convertitore €/Ar", compare: "Confronta le zone", quiz: "Quale investimento fa per te?",
      calcTitle: "Calcolatore dei costi d'acquisto",
      calcPrice: "Prezzo dell'immobile (€)", calcResult: "Costo totale stimato",
      calcRows: { price: "Prezzo d'acquisto", notary: "Notaio e registrazione (~4–6%)", legal: "Verifica legale (due diligence)", company: "Costituzione società (se necessaria)", agency: "Accompagnamento e mediazione", total: "Totale indicativo" },
      calcNote: "Stima orientativa basata su casi tipici: i costi reali dipendono dalla struttura scelta e dal professionista. Te la confermiamo per iscritto prima di qualsiasi impegno.",
      convTitle: "Convertitore Euro / Ariary",
      convNote: "Tasso indicativo: 1 € ≈ 4.900 Ar. Il tasso reale varia ogni giorno: verificalo prima di un pagamento.",
      convEur: "Euro (€)", convMga: "Ariary (Ar)",
      compareTitle: "Confronta le zone",
      comparePick: "Scegli fino a 3 zone da confrontare",
      compareRows: { profile: "Profilo", price: "Prezzi indicativi", climate: "Clima", access: "Come arrivare", best: "Ideale per" },
      quizTitle: "Quale investimento fa per te?",
      quizStart: "Inizia il quiz", quizRestart: "Ricomincia", quizResult: "Il nostro suggerimento",
      quizNext: "Avanti", quizCta: "Parliamone in una consulenza gratuita",
      quizDisclaimer: "Il risultato è un'indicazione di massima, non una consulenza. Ne parliamo insieme prima di decidere.",
    },
    notFound: { title: "Pagina non trovata", text: "La pagina che cerchi non esiste o è stata spostata. Come una pista nell'altipiano: a volte il percorso cambia.", cta: "Torna alla home" },
    seo: {
      homeTitle: "Investire in Madagascar — Terreni, immobili e terreni agricoli verificati",
      homeDesc: "Opportunità di investimento immobiliare e agricolo in Madagascar con verifica legale, schede di trasparenza e accompagnamento in italiano.",
    },
  },
  en: {
    brand: "Invest in Madagascar",
    nav: {
      properties: "Properties", farmland: "Farmland", services: "Services", zones: "Areas",
      guides: "Guides", about: "About", contact: "Contact", cta: "Book a consultation",
      tools: "Tools", howItWorks: "How it works", testimonials: "Testimonials", faq: "FAQ", sell: "List your property",
    },
    common: {
      all: "All", readMore: "Read more", viewProperty: "View property", featured: "Featured",
      example: "Example", available: "Available", reserved: "Reserved", sold: "Sold",
      priceOnRequest: "Price on request", photosComingSoon: "Real photos coming soon",
      back: "Back", close: "Close", send: "Send", sending: "Sending...",
      required: "Required field", invalidEmail: "Invalid email",
      errorGeneric: "Something went wrong. Please try again or contact us directly.",
      privacyRequired: "You must accept the privacy policy to continue",
      grid: "Grid", list: "List", compare: "Compare", favorites: "Favourites",
      results: "results", fromSea: "from the sea", fromAirport: "from the airport", built: "Built area",
      landSurface: "Surface", disclaimerShort: "Information is provided for general guidance only and does not constitute legal, tax or financial advice.",
      demoData: "Demo listing with invented data, to be replaced before launch",
      menu: "Menu", search: "Search", newOpportunity: "New opportunity",
    },
    types: {
      beachfront: "Beachfront", land: "Land", house: "Houses", villa: "Villas",
      hospitality: "Hospitality", farmland: "Farmland",
    },
    hero: {
      line1: "Red earth,",
      line2: "deep ocean,",
      line3: "your investment.",
      subtitle: "Verified land, property and farmland in Madagascar. We walk with you through every step, from the first visit to the notary's signature — honestly, about risks and costs.",
      searchTitle: "Find your opportunity",
      typeLabel: "Type", zoneLabel: "Area", budgetLabel: "Budget",
      budgetAny: "Any budget", zoneAny: "All areas", typeAny: "All types",
      submit: "Search properties",
      budgetOptions: ["Under €20,000", "€20,000–50,000", "€50,000–150,000", "Over €150,000"],
      scroll: "Scroll",
    },
    trust: {
      title: "A method, not promises",
      items: [
        { value: "9", label: "Areas covered across the country" },
        { value: "[XX]", label: "Years of experience — to be confirmed" },
        { value: "[XXX]", label: "Clients assisted — to be confirmed" },
        { value: "100%", label: "Listings with a transparency sheet" },
      ],
    },
    home: {
      featuredTitle: "Featured opportunities",
      featuredSub: "A selection of listings verified by our team. Every property includes a transparency sheet: what we checked and which risks remain.",
      viewAll: "View all properties",
      mapTitle: "One island, nine worlds",
      mapSub: "From the lagoons of Nosy Be to the farming highlands: explore the areas where we work and find the one that fits you.",
      mapCta: "Explore the areas",
      stepsTitle: "How it works",
      stepsSub: "Four clear steps, one point of contact who speaks your language.",
      servicesTitle: "More than real estate",
      servicesSub: "Legal due diligence, company setup, residency, scouting trips and management: a complete bridge between you and Madagascar.",
      allServices: "All services",
      residencyTitle: "Living in Madagascar",
      residencyText: "Residency routes for investors, retirees and professionals. We help you understand requirements, timelines and documents — and we tell you upfront if your situation is not a fit.",
      residencyCta: "Discover the residency programme",
      whyTitle: "Why Madagascar",
      whySub: "A frontier market: low entry prices and great potential, but real risks too. Here are the facts, without the hype.",
      zonesTitle: "Where to invest",
      zonesSub: "Nine areas we know on the ground, each with its own profile: tourism, residence, agriculture.",
      testimonialsTitle: "Hear from our clients",
      testimonialsNote: "We only publish real testimonials authorised in writing. These are placeholder cards to be replaced before launch.",
      guideTitle: "The free guide to get started",
      guideSub: "“Investing in Madagascar: the honest guide” — 40 pages on the market, the law, real costs and mistakes to avoid.",
      guideCta: "Download the free guide",
      guideSuccess: "Done! Check your inbox: we sent you the download link.",
      articlesTitle: "Guides and insights",
      articlesSub: "Practical articles written by people who work on the ground, not by dream sellers.",
      allArticles: "All articles",
      faqTitle: "Frequently asked questions",
      faqSub: "The answers we give most often, no beating around the bush.",
      allFaq: "All FAQs",
      ctaTitle: "Let's talk, no strings attached",
      ctaSub: "Tell us your idea: we'll honestly tell you if and how it can be done in Madagascar.",
      ctaButton: "Book a free consultation",
      marquee: "Verified titles • English-speaking support • Transparency sheets • No promised returns • Organised site visits • Local legal support • ",
    },
    listings: {
      title: "All properties",
      sub: "Every listing shows what we verified and which risks remain. No surprises after signing.",
      filters: "Filters", type: "Type", zone: "Area", priceMin: "Min price", priceMax: "Max price",
      surfaceMin: "Min surface (m²)", beachfrontOnly: "Beachfront only", statusLabel: "Status",
      reset: "Reset filters", sortNewest: "Newest", sortPriceAsc: "Price low to high", sortPriceDesc: "Price high to low", sortSurface: "Surface",
      empty: "No property matches your filters. Try widening the search or contact us: we often know of opportunities not yet published.",
      compareBar: "properties selected for comparison", compareNow: "Compare now", compareTitle: "Property comparison",
      compareMax: "You can compare up to 3 properties",
      favAdded: "Added to favourites", favRemoved: "Removed from favourites", showFavs: "Show favourites",
      refCode: "Code", price: "Price", surface: "Surface", zoneCol: "Area",
      presetTitles: { beachfront: "Beachfront land", land: "Building land", houses: "Houses & villas", hospitality: "Hospitality properties", sold: "Sold properties", farmland: "Farmland" },
      presetSubs: {
        beachfront: "Verified plots directly on the beach or with direct sea access.",
        land: "Building and residential land with verified title.",
        houses: "Houses and villas, ready or to renovate.",
        hospitality: "Lodges, boutique hotels and hospitality businesses.",
        sold: "Archive of sold properties: real market prices and timelines.",
        farmland: "Fertile farmland with water and verified title.",
      },
    },
    property: {
      keyFacts: "Key facts", description: "Description", transparency: "Transparency sheet",
      rightType: "Type of right offered", titleStatus: "Title status", checks: "Checks performed",
      risks: "Known risks", extraCosts: "Indicative additional costs",
      extraCostsText: "Legal due diligence, notary, registration and possible company setup are not included in the price. Rough estimate: 8–15% of the purchase price. Use the cost calculator for details.",
      mapTitle: "Location", approxLocation: "Indicative location: for privacy reasons the exact point is shared after the first contact.",
      similar: "Similar properties", contactTitle: "Request information",
      contactSub: "Fill in the form: we reply within 24 working hours, in your language.",
      whatsappMsg: "Hello, I saw property {ref} ({title}) on Invest in Madagascar and would like more information.",
      updated: "Listing updated on", mortgage: "Sheet verified by our team",
    },
    farmlandPage: {
      title: "Farmland",
      sub: "Fertile land with water, verified title and — if you wish — local management. Agriculture is one of Madagascar's highest-potential sectors, but it requires skill and patience.",
      whyTitle: "Why agriculture in Madagascar",
      whyPoints: [
        { t: "Fertile land at affordable prices", d: "In the highlands and on the coast, per-hectare prices are a fraction of European ones, with climates allowing multiple harvests a year." },
        { t: "Water and climate", d: "Many areas have abundant rainfall or springs. We always verify water rights before proposing land." },
        { t: "Remote management possible", d: "With local management agreements you can produce even without living there. We introduce you to proven operators." },
      ],
      cta: "See available farmland",
    },
    form: {
      name: "Full name", email: "Email", phone: "Phone / WhatsApp", phoneHint: "With country code, e.g. +44",
      country: "Country of residence", budget: "Budget range", timeline: "Timeline",
      timelineOptions: ["Within 3 months", "3–12 months", "Over a year", "Just researching"],
      budgetOptions: ["Under €20,000", "€20,000–50,000", "€50,000–150,000", "Over €150,000"],
      message: "Message", contactPref: "How should we contact you?",
      contactPrefOptions: ["Email", "WhatsApp", "Video call"],
      privacy: "I have read and accept the privacy policy",
      newsletter: "I want the monthly newsletter with new opportunities (optional)",
      submit: "Send request", success: "Request sent! We'll get back to you within 24 working hours.",
      selectPlaceholder: "Select...",
      countries: ["Italy", "France", "Germany", "Switzerland", "Spain", "United Kingdom", "Belgium", "Netherlands", "Austria", "Other"],
      messagePrefill: "Hello, I would like more information about \"{title}\" (ref. {ref}).",
      guideName: "Name", guideEmail: "Your email", guideSubmit: "Download the guide",
      newsletterSubmit: "Subscribe", newsletterSuccess: "Subscription confirmed. Welcome aboard!",
    },
    popup: {
      title: "Before you go: the free guide",
      text: "“Investing in Madagascar: the honest guide” — market, law, real costs and mistakes to avoid. 40 pages, zero advertising.",
      later: "No thanks, maybe later",
    },
    cookie: {
      title: "We respect your privacy",
      text: "We use technical cookies to make the site work and — only with your consent — measurement cookies to understand how it is used. No tracking starts without your ok.",
      accept: "Accept", reject: "Reject", customize: "Customise", save: "Save preferences",
      necessary: "Technical (always on)", analytics: "Anonymous measurement", marketing: "Marketing",
    },
    footer: {
      tagline: "The transparent bridge between European investors and verified real-estate and agricultural opportunities in Madagascar.",
      explore: "Explore", company: "Company", legal: "Legal", contacts: "Contacts",
      newsletterTitle: "New opportunities, once a month",
      newsletterSub: "Only verified listings and one article from our guides. No spam.",
      companyData: "[COMPANY NAME] · [REGISTERED ADDRESS] · [VAT / FOREIGN ID]",
      email: "[EMAIL]", whatsapp: "[WHATSAPP NUMBER]",
      disclaimer: "Information on this website is provided for general guidance only and does not constitute legal, tax or financial advice. Investing abroad involves risk, including possible loss of capital. Always seek qualified professional advice before making any decision.",
      rights: "All rights reserved.",
    },
    tools: {
      title: "Decision-making tools",
      sub: "Numbers first: calculate real costs, convert to Ariary, compare areas and find out which investment fits you.",
      calc: "Cost calculator", converter: "€/Ar converter", compare: "Compare areas", quiz: "Which investment suits you?",
      calcTitle: "Purchase cost calculator",
      calcPrice: "Property price (€)", calcResult: "Estimated total cost",
      calcRows: { price: "Purchase price", notary: "Notary & registration (~4–6%)", legal: "Legal due diligence", company: "Company setup (if needed)", agency: "Support & brokerage", total: "Indicative total" },
      calcNote: "Rough estimate based on typical cases: real costs depend on the chosen structure and the professional. We confirm them in writing before any commitment.",
      convTitle: "Euro / Ariary converter",
      convNote: "Indicative rate: €1 ≈ Ar 4,900. The real rate changes daily: check it before any payment.",
      convEur: "Euro (€)", convMga: "Ariary (Ar)",
      compareTitle: "Compare areas",
      comparePick: "Pick up to 3 areas to compare",
      compareRows: { profile: "Profile", price: "Indicative prices", climate: "Climate", access: "Getting there", best: "Best for" },
      quizTitle: "Which investment suits you?",
      quizStart: "Start the quiz", quizRestart: "Restart", quizResult: "Our suggestion",
      quizNext: "Next", quizCta: "Discuss it in a free consultation",
      quizDisclaimer: "The result is a rough indication, not advice. Let's talk it through before deciding.",
    },
    notFound: { title: "Page not found", text: "The page you are looking for does not exist or has been moved. Like a highland track: sometimes the route changes.", cta: "Back to home" },
    seo: {
      homeTitle: "Invest in Madagascar — Verified land, property and farmland",
      homeDesc: "Real-estate and agricultural investment opportunities in Madagascar with legal due diligence, transparency sheets and English-speaking support.",
    },
  },
};
